import axios from 'axios';
import { setErrorInterceptor } from '../interceptors';
import store from '../store';

axios.defaults.baseURL = '/';
axios.interceptors.response.use(null, (error) => setErrorInterceptor(error, store));

export const generateSource = () => axios.CancelToken.source();

export const getCancelToken = (source) => source.token;

export const cancelRequest = (source) => {
  const message = 'Cancel request';
  return source.cancel(message);
};

export const isCancel = (error) => axios.isCancel(error);

export default axios;
